const updateUserAccessBySuperadmin = {
  toastr: 'Usuario actualizado',
  toastr1: ' fue actualizado con éxito',
  toastrError: 'Nombre ya registrado',
  toastrError: 'Ingrese otro nombre'
};

export default updateUserAccessBySuperadmin;
